import { collection, getDocs, query, orderBy, limit, startAfter, getCountFromServer  } from 'firebase/firestore';
import { db } from "../config/firebase/firebase";

export const fetchCvReport = async (email, pageSize = 10, startAfterDoc = null) => {
    const jobStatsCollection = collection(db, `users/${email}/cv.report`);

    let q = query(
        jobStatsCollection,
        orderBy('createdAt', 'desc'),
        ...(startAfterDoc ? [startAfter(startAfterDoc)] : []),
        limit(pageSize)
    );

    const snapshot = await getDocs(q);
    const data = snapshot.docs.map((doc) => ({
        id: doc.id,
        ...doc.data(),
    }));
    return { data, lastDoc: snapshot.docs[snapshot.docs.length - 1], snapshot };
};


export const getCvReportCount = async (email) => {
    const jobStatsCollection = collection(db, `users/${email}/cv.report`);
    const snapshot = await getCountFromServer(jobStatsCollection);
    return snapshot.data().count;
};

